import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { FormControl, FormItem, FormLabel } from "@ui/Form";
import { RadioGroup, RadioGroupItem } from "@ui/RadioGroup";
import { cn } from "@/utils/tailwind";

export type YesNoValue = "true" | "false";

interface YesNoRadioProps {
  value?: YesNoValue;
  onChange: (value: YesNoValue) => void;
  id: string;
  className?: string;
  dataTestPrefix?: string;
}

const YesNoRadio: FC<YesNoRadioProps> = ({ value, onChange, id, className, dataTestPrefix }) => {
  const { t } = useTranslation();

  const options: { value: YesNoValue; label: string }[] = [
    { value: "false", label: t("no") },
    { value: "true", label: t("yes") },
  ];

  return (
    <RadioGroup
      onValueChange={onChange}
      value={value ?? ""}
      className={cn("flex flex-col sm:px-4", className)}
    >
      {options.map(({ value, label }) => (
        <FormItem key={value} className="flex items-center gap-[11.5px]">
          <FormControl>
            <RadioGroupItem
              id={`${id}-${value}`}
              value={value}
              data-test={dataTestPrefix ? `${dataTestPrefix}-${value}` : undefined}
            />
          </FormControl>
          <FormLabel htmlFor={`${id}-${value}`} className="cursor-pointer font-normal">
            {label}
          </FormLabel>
        </FormItem>
      ))}
    </RadioGroup>
  );
};

export default YesNoRadio;
